import PropTypes from "prop-types";
import { FormControl } from "react-bootstrap";
import MaskedInput from "react-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";

const defaultMaskOptions = {
  //   prefix: "Rp ",
  //   suffix: "",
  includeThousandsSeparator: true,
  //   thousandsSeparatorSymbol: ",",
  allowDecimal: false,
  decimalSymbol: ",",
  decimalLimit: 5, // how many digits allowed after the decimal
  integerLimit: 20, // limit length of integer numbers
  allowNegative: false,
  allowLeadingZeroes: false,
};

const PrefixSuffixInput = ({ maskOptions, ...inputProps }) => {
  const currencyMask = createNumberMask({
    ...defaultMaskOptions,
    ...maskOptions,
    allowDecimal: false,
  });

  return <FormControl mask={currencyMask} {...inputProps} as={MaskedInput} />;
};
PrefixSuffixInput.defaultProps = {
  inputMode: "numeric",
  maskOptions: {},
};

PrefixSuffixInput.propTypes = {
  inputmode: PropTypes.string,
  maskOptions: PropTypes.shape({
    prefix: PropTypes.string,
    suffix: PropTypes.string,
    includeThousandsSeparator: PropTypes.bool,
    thousandsSeparatorSymbol: PropTypes.string,
    allowDecimal: PropTypes.bool,
    decimalSymbol: PropTypes.string,
    decimalLimit: PropTypes.string,
    requireDecimal: PropTypes.bool,
    allowNegative: PropTypes.bool,
    allowLeadingZeroes: PropTypes.bool,
    integerLimit: PropTypes.number,
  }),
};

export default PrefixSuffixInput;
